import { Location } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { CampaignService } from '@app/_core/services/campaign.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { AssignAgentsComponent } from '@app/pages/common/assign-agents/assign-agents.component';
import { catchError, EMPTY, map } from 'rxjs';

@Component({
  selector: 'app-campaign-details',
  templateUrl: './campaign-details.component.html',
  styleUrls: ['./campaign-details.component.scss'],
})
export class CampaignDetailsComponent {
  @ViewChild(AssignAgentsComponent)
  private assignAgentComponent!: AssignAgentsComponent;

  campaignDetail: any;
  title: string = '';

  userRoles: any = [];
  users: any;
  //"group", "user", this.service(), "GetGroupUsers", false, false, true, !cls.
  owner = 'group';
  object = 'user';
  priorities = false;
  persistence = false;
  roles = true;
  disable;
  details: any;
  channels: any = [{ label: 'Voice' }, { label: 'Text' }];
  channelTypes: any = [{ label: 'Ask' }, { label: 'Hangup' }];
  status: any = [
    { label: 'Pending' },
    { label: 'Ready' },
    { label: 'Complete' },
    { label: 'Cancelled' },
    { label: 'Paused' },
  ];
  selectedChannel: any;
  selectedChannelType: any;
  weekdays: any[] = [];
  availabeOnDay: string = '';
  currentpath: any = '';
  campaignRunActiveStartTime: any;
  campaignRunActiveEndTime: any;
  campaignRunActiveTimeZone: string;
  timeZones: any;
  pending: boolean;
  ready: boolean;
  completed: boolean;
  cancelled: boolean;
  paused: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private location: Location,
    private campaignService: CampaignService
  ) {
    this.route.params.subscribe((params: any) => {
     // console.log('params.id', params.id);
      // alert(params.id)
      this.loadCampaignDetails(params.id);
    });
   // console.log(this.status, 'status');
    const urlArray: any = this.router.url.split('/');
    urlArray.shift();
    if (urlArray.length > 0) {
      for (let i = 0; i < urlArray.length - 1; i++) {
        this.currentpath += urlArray[i] + (urlArray[i + 2] ? '>' : '');
      }
    }
    this.disable = this.securityService.validateGrant('ManageAssignments');
    this.weekdays = [
      { label: 'Mon', checked: false },
      { label: 'Tue', checked: false },
      { label: 'Wed', checked: false },
      { label: 'Thu', checked: false },
      { label: 'Fri', checked: false },
      { label: 'Sat', checked: false },
    ];
    this.timeZones = [
      {
        label: 'Eastern Standard Time',
        value: '(UTC-05:00) Eastern Time (US & Canada)',
      },
    ];
    this.campaignRunActiveTimeZone = this.timeZones[0].label;

    if (this.status[0].label == 'Pending') {
      this.pending = true;
      this.cancelled = false;
    } else if (this.status[0].label == 'Ready') {
      this.ready = false;
    } else if (this.status[0].label == 'Completed') {
      this.completed = false;
    } else if (this.status[0].label == 'Cancelled') {
      this.cancelled = false;
    } else if (this.status[0].label == 'Paused') {
      this.paused = false;
    }
  }

  loadCampaignDetails(id: number) {
    this.campaignService
      .getCampaignById(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetCampaignByID');
          if (isValid) {
            this.campaignDetail = data.Response.Data;
          //  console.log('this.campaignDetail', this.campaignDetail);
            this.title =
              'Group ' +
              this.campaignDetail.ID +
              ' - ' +
              this.campaignDetail.Name +
              (this.campaignDetail.Manager == null ? '' : ' (Manager: ' + this.campaignDetail.Manager + ')');

            this.details = {
              ID: this.campaignDetail.ID,
              owner: this.owner,
              object: this.object,
              service: this.managerService,
              method: 'GetGroupUsers',
              priorities: this.priorities,
              persistence: this.persistence,
              roles: this.roles,
              disable: !this.securityService.validateGrant('ManageAssignments'),
            };
            this.setAvailableOn();
            this.setTimeBetween();
            //  AssignmentController("group", "user", this.service(), "GetGroupUsers", false, false, true, !cls.QBRSecurity().validateGrant("ManageAssignments"));
            //this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  setAvailableOn() {
    switch (this.campaignDetail.CampaignRun.ActiveDays) {
      case 1:
        this.availabeOnDay = 'Sun';
        break;
      case 2:
        this.availabeOnDay = 'Mon';
        break;
      case 4:
        this.availabeOnDay = 'Tue';
        break;
      case 8:
        this.availabeOnDay = 'Wed';
        break;
      case 16:
        this.availabeOnDay = 'Thu';
        break;
      case 32:
        this.availabeOnDay = 'Fri';
        break;
      case 64:
        this.availabeOnDay = 'Sat';
        break;
    }

    this.weekdays = this.weekdays.filter((item: any) => {
      if (item.label === this.availabeOnDay) {
        item.checked = true;
      }
      return this.weekdays;
    });
    //sunday.selected((this.campaignDetail.ActiveDays & 1) == 1);
    //monday.selected((this.campaignDetail.ActiveDays & 2) == 2);
    //tuesday.selected((this.campaignDetail.ActiveDays & 4) == 4);
    //wednesday.selected((this.campaignDetail.ActiveDays & 8) == 8);
    //thursday.selected((this.campaignDetail.ActiveDays & 16) == 16);
    //friday.selected((this.campaignDetail.ActiveDays & 32) == 32);
    //saturday.selected((data.CampaignRun.ActiveDays & 64) == 64);
    //runningTime.value(im.Utils.formatDuration(this.campaignDetail.RunningTime, 'second', true, true));
    //progress.inputViewWidth((completedRecords / totalRecords) * 75 + '%');
    //actionsBtnHolder.visible(true);
    //newPromptHolder.visible(false);
    //promptHolder.visible(true);
  }

  setTimeBetween() {
   // console.log('setTimeBetween');
    //this.campaignDetail.CampaignRun.ActiveStartTime = this.campaignDetail.CampaignRun.ActiveStartTime/100
    //this.campaignDetail.CampaignRun.ActiveEndTime = this.campaignDetail.CampaignRun.ActiveEndTime/100;
    this.campaignRunActiveStartTime = this.convertTo12HourFormat(this.campaignDetail.CampaignRun.ActiveStartTime);
    this.campaignRunActiveEndTime = this.convertTo12HourFormat(this.campaignDetail.CampaignRun.ActiveEndTime);
  }

  setTimeZone() {
    if (this.campaignDetail.CampaignRun.ActiveEndTime === 'Eastern Standard Time') {
      this.campaignRunActiveTimeZone = '(UTC-05:00) Eastern Time (US & Canada)';
    }
  }

  convertTo12HourFormat(time24Hour) {
    if (!Number.isInteger(time24Hour) || time24Hour < 0 || time24Hour >= 2400) {
      return 'Invalid input. Please provide a valid 24-hour time (e.g., 2300).';
    }
    const hours = Math.floor(time24Hour / 100);
    const minutes = time24Hour % 100;
    let amPm = 'AM';
    let convertedHours = hours;
    if (hours >= 12) {
      amPm = 'PM';
    } else if (hours === 0) {
      convertedHours = 12;
    }
    return `${convertedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  saveChanges() {
    const pl: any = {};
    const agents = [];
    const assignedAgents = this.assignAgentComponent.assignedDisplay;
    for (const agent of assignedAgents) {
      agents.push(agent.value + '|' + this.getUserRole(agent.label));
    }
    pl.agents = agents;
    pl.id = this.campaignDetail.ID;
    this.managerService
      .EditCampaignDetails(pl)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'EditcampaignDetails');
          if (isValid) {
            this.location.back();
          }
        })
      )
      .subscribe();
  }

  getUserRole(label: any) {
    if (label.lastIndexOf(' (Manager)') > -1) {
      return 2;
    } else return 1;
  }
  goBack() {
    this.location.back();
  }
}
